import { Injectable } from '@angular/core';
import { SegmentsRepository } from '@core/repositories/segments.repository';
import { Segment } from '@shared/interfaces/segment';
import { Observable, of, throwError } from 'rxjs';

interface ResultSegment {
  id: string;
  attributes: {
    name: string;
  };
}

@Injectable({ providedIn: 'root' })
export class FakeSegmentsRepository implements SegmentsRepository {
  dataSegments: Array<ResultSegment> = [
    {
      id: '301',
      attributes: {
        name: 'S3'
      }
    },
    {
      id: '401',
      attributes: {
        name: 'S4'
      }
    },
    {
      id: '501',
      attributes: {
        name: 'S5'
      }
    }
  ];

  segments = {
    data: this.dataSegments
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.segments);
  }

  add(segment: Segment): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(segment: Segment): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
